import { render, staticRenderFns } from "./RegisterCalender.vue?vue&type=template&id=9624455c&"
import script from "./RegisterCalender.vue?vue&type=script&lang=js&"
export * from "./RegisterCalender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports